/**
 * 工作機械関連の定数定義
 */
export const MACHINE_CONSTANTS = {
    // 出力タイプ
    OUTPUT_TYPES: {
        DXF: 'DXF', // DXF形式
        CSV: 'CSV', // CSV形式
        NC: 'NC',   // NC形式
        REPORT: 'レポート', // レポート形式
    },

    // 機械タイプ
    MACHINE_TYPES: {
        MILL: 'ミル', // ミルタイプ
        LATHE: '旋盤' // 旋盤タイプ
    },

    // モデルタイプ
    MODEL_TYPES: [
        { value: 'FUNAC', label: 'FUNAC' }, // FUNACモデル
        { value: 'OSP', label: 'OSP' },     // OSPモデル
        { value: 'MELDAS', label: 'MELDAS' }, // MELDASモデル
        { value: 'MAZAK', label: 'MAZAK' },   // MAZAKモデル
        { value: 'OKK', label: 'OKK' },       // OKKモデル
        { value: 'GERBER', label: 'GERBER' }  // GERBERモデル
    ]
} as const;